<template>
  <div class="my_notifications_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="created_at"
      pagination-simple
      per-page="15"
      :data="requestsList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      backend-pagination
      :total="total"
    >
      <template slot-scope="props">
        <b-table-column label="Дата" :visible="true" field="created_at" :centered="false" sortable width="10%">
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="ФИО" :visible="true" field="name" :centered="false" sortable width="25%">
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Телефон" :visible="true" field="phone" :centered="false" sortable width="15%">
          <div>{{ props.row.phone }}</div>
        </b-table-column>
        <b-table-column label="Регион" :visible="true" field="region" :centered="false" sortable width="20%">
          <div>{{ props.row.region }}</div>
        </b-table-column>
        <b-table-column label="Комментарий" :visible="true" field="comment" :centered="false" sortable width="25%">
          <div>{{ props.row.comment }}</div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    requestsList: {
      default: () => [],
      type: Array
    },
    total: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  methods: {
    changePage(val) {
      this.$emit('changePage', val)
    }
  }
}
</script>
